import React, { useState, useEffect } from 'react'
import { Tour } from 'antd'
import type { TourStepProps } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import {
  currentUserRoleSelector,
  currentUserTourCompletedSelector,
  currentUserSelector,
  currentUserTermsConditionsSelector
} from '../../redux/session/currentUser/selectors'
import { contextCompanyIdSelector } from '../../redux/context/company/selectors'
import { getCompanySteps } from './intro/CompanyIntro'
import { getAccountantSteps } from './intro/AccountantIntro'
import { tourCompletedRequest } from '../../redux/session/currentUser/actions'
import { useLoggedin, usePermission } from '../../redux/session/currentUser/hooks'
import { getCompanyLiteSteps } from './intro/CompanyLiteIntro'
import { AppDispatch } from '../../redux/store'

const UserTour: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [steps, setSteps] = useState<TourStepProps[]>([])
  const role = useSelector(currentUserRoleSelector)
  const isLoggedIn = useLoggedin()
  const tourCompleted = useSelector(currentUserTourCompletedSelector)
  const currentUser = useSelector(currentUserSelector)
  const termsConditionsAgreed = useSelector(currentUserTermsConditionsSelector)
  const writeBudgetsPermission = usePermission('write-budgets')
  const companyId = useSelector(contextCompanyIdSelector)
  const dispatch: AppDispatch = useDispatch()

  const closeTour = () => {
    setIsOpen(false)
  }

  const tourHandler = () => {
    if (isLoggedIn && !tourCompleted && termsConditionsAgreed && companyId) {
      if (role.label.includes('accountant')) {
        setIsOpen(true)
        setSteps(getAccountantSteps())
      } else if (role.label.includes('company')) {
        setIsOpen(true)
        if (writeBudgetsPermission) setSteps(getCompanySteps())
        else setSteps(getCompanyLiteSteps())
      }
    }
  }

  useEffect(tourHandler, [
    isLoggedIn,
    tourCompleted,
    termsConditionsAgreed,
    role,
    writeBudgetsPermission,
    companyId,
    currentUser
  ])

  const userTourCompleted = () => {
    dispatch(tourCompletedRequest())
  }

  return <Tour steps={steps} open={isOpen} onClose={closeTour} onFinish={userTourCompleted} />
}

export default UserTour
